var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import api from '@utils/axios';
import { newReportEmailPath } from '@routes';
/** Loads the contacts and default subject/body each time the modal opens for a report. */
export default function useReportEmailDraft(reportId) {
    const [state, setState] = useState({ draft: null, loading: false, failed: false });
    useEffect(() => {
        if (reportId === null)
            return undefined;
        let cancelled = false;
        setState({ draft: null, loading: true, failed: false });
        void (() => __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield api.get(newReportEmailPath(reportId));
                if (!cancelled)
                    setState({ draft: data, loading: false, failed: false });
            }
            catch (_a) {
                if (!cancelled)
                    setState({ draft: null, loading: false, failed: true });
            }
        }))();
        return () => {
            cancelled = true;
        };
    }, [reportId]);
    return state;
}
